import React, { useId } from "react";
import PetsIcon from "@mui/icons-material/Pets";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

export default function PetFriendlySeal({ size = 240, fill = "transparent", labelTop = "PET FRIENDLY", labelBottom = "PORTA LA TEVA MASCOTA" }) {
    const theme = useTheme();
    const primary = theme.color.primary;

    const uid = useId();
    const topPathId = `seal-top-${uid}`;
    const bottomPathId = `seal-bottom-${uid}`;
    const glowId = `seal-glow-${uid}`;

    const cx = size / 2;
    const cy = size / 2;

    const strokeOuter = Math.max(2, size * 0.02);
    const strokeInner = Math.max(1.5, size * 0.01);

    const rOuter = size * 0.38;
    const rOuterO = size * 0.405;
    const rDashed = rOuter - size * 0.13;
    const rText = rOuter - size * 0.04;

    return (
        <Box
            sx={{
                position: "relative",
                width: size,
                height: size,
                display: "inline-block",
                filter: `
          drop-shadow(0 0 12px #F4E9D7)
          drop-shadow(0 0 24px #F4E9D7)
        `,
            }}
            aria-label="Segell Pet Friendly"
        >
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img">
                <defs>
                    {/* Glow clar */}
                    <filter id={glowId} x="-40%" y="-40%" width="180%" height="180%">
                        <feGaussianBlur stdDeviation={size * 0.02} result="blur" />
                        <feColorMatrix
                            in="blur"
                            type="matrix"
                            values="
                1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 0.6 0
              "
                        />
                    </filter>

                    {/* Camins text */}
                    <path id={topPathId} d={`M ${cx - rText} ${cy} A ${rText} ${rText} 0 0 0 ${cx + rText} ${cy}`} />
                    <path id={bottomPathId} d={`M ${cx - rText} ${cy} A ${rText} ${rText} 0 0 1 ${cx + rText} ${cy}`} />
                </defs>

                {/* Anell exterior fi */}
                <circle cx={cx} cy={cy} r={rOuterO} fill={fill} stroke={primary} strokeWidth={Math.max(2, size * 0.008)} />
                <circle cx={cx} cy={cy} r={rOuterO} fill={fill} stroke={primary} strokeWidth={Math.max(2, size * 0.008)} filter={`url(#${glowId})`} />

                {/* Cercle exterior principal */}
                <circle cx={cx} cy={cy} r={rOuter} fill={fill} stroke={primary} strokeWidth={strokeOuter} />
                <circle cx={cx} cy={cy} r={rOuter} fill={fill} stroke={primary} strokeWidth={strokeOuter} filter={`url(#${glowId})`} />

                {/* Cercle dashed */}
                <circle
                    cx={cx}
                    cy={cy}
                    r={rDashed}
                    fill="none"
                    stroke={primary}
                    strokeWidth={strokeInner}
                    strokeDasharray={`${size * 0.02} ${size * 0.02}`}
                    opacity="0.9"
                />

                {/* Text superior */}
                <text
                    fill={primary}
                    fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif"
                    fontWeight="800"
                    fontSize={Math.max(12, size * 0.075)}
                    letterSpacing={Math.max(0.8, size * 0.006)}
                >
                    <textPath href={`#${topPathId}`} startOffset="50%" textAnchor="middle">
                        {labelTop}
                    </textPath>
                </text>

                {/* Text inferior */}
                <text
                    fill={primary}
                    fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif"
                    fontWeight="800"
                    fontSize={Math.max(12, size * 0.075)}
                    letterSpacing={Math.max(0.8, size * 0.002)}
                    dy={size * 0.05}
                >
                    <textPath href={`#${bottomPathId}`} startOffset="50%" textAnchor="middle">
                        {labelBottom}
                    </textPath>
                </text>
            </svg>

            {/* Icona central */}
            <PetsIcon
                sx={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: size * 0.34,
                    color: primary,
                    pointerEvents: "none",
                    filter: `
            drop-shadow(0 0 10px ${primary}66)
          `,
                }}
            />
        </Box>
    );
}
